import { Type } from "@angular/core";
import { ArcgisLayerLegend } from "./arcgis-legend-response.model";

export interface ILayerLegend {
    label: string;
    imageData: string;
    contentType: string;
    width: number;
    height: number;
}

export class LayerLegend implements ILayerLegend {
    get src(): string {
        if(!this.contentType) {
            return this.imageData;
        } else {
            return `data:${this.contentType}; base64,${this.imageData}`;
        }
    }

    private constructor(public label: string,
                             public imageData: string,
                             public contentType: string,
                             public width: number,
                             public height: number) {

    }

    static fromInterface(other?: ArcgisLayerLegend): LayerLegend {
        if (!other) {
            return undefined;
        }

        return new LayerLegend(
            other.label,
            other.imageData,
            other.contentType,
            other.width,
            other.height);
    }
}

export interface ICustomLegend {
    component: Type<any>;
    inputs: Record<string, unknown>;
}
